module.exports = __webpack_public_path__ + "static/media/pause.4c15f622.svg";